import { createContext as _, useMemo as C, createElement as m, useContext as R, useCallback as F, Fragment as te, forwardRef as E, Children as P, isValidElement as x, cloneElement as M, useRef as p, useEffect as b, useState as D, useLayoutEffect as oe, useReducer as re } from "react";
import se, { flushSync as X } from "react-dom";
function h() {
  return h = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var o in t)
        ({}).hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, h.apply(null, arguments);
}
function xe(e, n = []) {
  let t = [];
  function o(s, a) {
    const i = /* @__PURE__ */ _(a), c = t.length;
    t = [
      ...t,
      a
    ];
    function u(l) {
      const { scope: $, children: v, ...y } = l, S = ($ == null ? void 0 : $[e][c]) || i, O = C(
        () => y,
        Object.values(y)
      );
      return /* @__PURE__ */ m(S.Provider, {
        value: O
      }, v);
    }
    function d(l, $) {
      const v = ($ == null ? void 0 : $[e][c]) || i, y = R(v);
      if (y)
        return y;
      if (a !== void 0)
        return a;
      throw new Error(`\`${l}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [
      u,
      d
    ];
  }
  const r = () => {
    const s = t.map((a) => /* @__PURE__ */ _(a));
    return function(i) {
      const c = (i == null ? void 0 : i[e]) || s;
      return C(
        () => ({
          [`__scope${e}`]: {
            ...i,
            [e]: c
          }
        }),
        [
          i,
          c
        ]
      );
    };
  };
  return r.scopeName = e, [
    o,
    ie(r, ...n)
  ];
}
function ie(...e) {
  const n = e[0];
  if (e.length === 1)
    return n;
  const t = () => {
    const o = e.map(
      (r) => ({
        useScope: r(),
        scopeName: r.scopeName
      })
    );
    return function(s) {
      const a = o.reduce((i, { useScope: c, scopeName: u }) => {
        const l = c(s)[`__scope${u}`];
        return {
          ...i,
          ...l
        };
      }, {});
      return C(
        () => ({
          [`__scope${n.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return t.scopeName = n.scopeName, t;
}
function ce(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function Z(...e) {
  return (n) => e.forEach(
    (t) => ce(t, n)
  );
}
function k(...e) {
  return F(Z(...e), e);
}
const q = /* @__PURE__ */ E((e, n) => {
  const { children: t, ...o } = e, r = P.toArray(t), s = r.find(ue);
  if (s) {
    const a = s.props.children, i = r.map((c) => c === s ? P.count(a) > 1 ? P.only(null) : /* @__PURE__ */ x(a) ? a.props.children : null : c);
    return /* @__PURE__ */ m(I, h({}, o, {
      ref: n
    }), /* @__PURE__ */ x(a) ? /* @__PURE__ */ M(a, void 0, i) : null);
  }
  return /* @__PURE__ */ m(I, h({}, o, {
    ref: n
  }), t);
});
q.displayName = "Slot";
const I = /* @__PURE__ */ E((e, n) => {
  const { children: t, ...o } = e;
  return /* @__PURE__ */ x(t) ? /* @__PURE__ */ M(t, {
    ...le(o, t.props),
    ref: n ? Z(n, t.ref) : t.ref
  }) : P.count(t) > 1 ? P.only(null) : null;
});
I.displayName = "SlotClone";
const ae = ({ children: e }) => /* @__PURE__ */ m(te, null, e);
function ue(e) {
  return /* @__PURE__ */ x(e) && e.type === ae;
}
function le(e, n) {
  const t = {
    ...n
  };
  for (const o in n) {
    const r = e[o], s = n[o];
    /^on[A-Z]/.test(o) ? r && s ? t[o] = (...i) => {
      s(...i), r(...i);
    } : r && (t[o] = r) : o === "style" ? t[o] = {
      ...r,
      ...s
    } : o === "className" && (t[o] = [
      r,
      s
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...t
  };
}
function L(e, n, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), t === !1 || !r.defaultPrevented)
      return n == null ? void 0 : n(r);
  };
}
function g(e) {
  const n = p(e);
  return b(() => {
    n.current = e;
  }), C(
    () => (...t) => {
      var o;
      return (o = n.current) === null || o === void 0 ? void 0 : o.call(n, ...t);
    },
    []
  );
}
function De({ prop: e, defaultProp: n, onChange: t = () => {
} }) {
  const [o, r] = de({
    defaultProp: n,
    onChange: t
  }), s = e !== void 0, a = s ? e : o, i = g(t), c = F((u) => {
    if (s) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && i(l);
    } else
      r(u);
  }, [
    s,
    e,
    r,
    i
  ]);
  return [
    a,
    c
  ];
}
function de({ defaultProp: e, onChange: n }) {
  const t = D(e), [o] = t, r = p(o), s = g(n);
  return b(() => {
    r.current !== o && (s(o), r.current = o);
  }, [
    o,
    r,
    s
  ]), t;
}
const fe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], w = fe.reduce((e, n) => {
  const t = /* @__PURE__ */ E((o, r) => {
    const { asChild: s, ...a } = o, i = s ? q : n;
    return b(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ m(i, h({}, a, {
      ref: r
    }));
  });
  return t.displayName = `Primitive.${n}`, {
    ...e,
    [n]: t
  };
}, {});
function ve(e, n) {
  e && X(
    () => e.dispatchEvent(n)
  );
}
const K = globalThis != null && globalThis.document ? oe : () => {
};
function $e(e, n) {
  return re((t, o) => {
    const r = n[t][o];
    return r ?? t;
  }, e);
}
const be = (e) => {
  const { present: n, children: t } = e, o = pe(n), r = typeof t == "function" ? t({
    present: o.isPresent
  }) : P.only(t), s = k(o.ref, r.ref);
  return typeof t == "function" || o.isPresent ? /* @__PURE__ */ M(r, {
    ref: s
  }) : null;
};
be.displayName = "Presence";
function pe(e) {
  const [n, t] = D(), o = p({}), r = p(e), s = p("none"), a = e ? "mounted" : "unmounted", [i, c] = $e(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return b(() => {
    const u = T(o.current);
    s.current = i === "mounted" ? u : "none";
  }, [
    i
  ]), K(() => {
    const u = o.current, d = r.current;
    if (d !== e) {
      const $ = s.current, v = T(u);
      e ? c("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && $ !== v ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [
    e,
    c
  ]), K(() => {
    if (n) {
      const u = (l) => {
        const v = T(o.current).includes(l.animationName);
        l.target === n && v && X(
          () => c("ANIMATION_END")
        );
      }, d = (l) => {
        l.target === n && (s.current = T(o.current));
      };
      return n.addEventListener("animationstart", d), n.addEventListener("animationcancel", u), n.addEventListener("animationend", u), () => {
        n.removeEventListener("animationstart", d), n.removeEventListener("animationcancel", u), n.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    n,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(i),
    ref: F((u) => {
      u && (o.current = getComputedStyle(u)), t(u);
    }, [])
  };
}
function T(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function me(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = g(e);
  b(() => {
    const o = (r) => {
      r.key === "Escape" && t(r);
    };
    return n.addEventListener("keydown", o), () => n.removeEventListener("keydown", o);
  }, [
    t,
    n
  ]);
}
const U = "dismissableLayer.update", he = "dismissableLayer.pointerDownOutside", ye = "dismissableLayer.focusOutside";
let V;
const G = /* @__PURE__ */ _({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ee = /* @__PURE__ */ E((e, n) => {
  var t;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: s, onFocusOutside: a, onInteractOutside: i, onDismiss: c, ...u } = e, d = R(G), [l, $] = D(null), v = (t = l == null ? void 0 : l.ownerDocument) !== null && t !== void 0 ? t : globalThis == null ? void 0 : globalThis.document, [, y] = D({}), S = k(
    n,
    (f) => $(f)
  ), O = Array.from(d.layers), [Q] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), Y = O.indexOf(Q), B = l ? O.indexOf(l) : -1, ee = d.layersWithOutsidePointerEventsDisabled.size > 0, W = B >= Y, ne = ge((f) => {
    const N = f.target, z = [
      ...d.branches
    ].some(
      (A) => A.contains(N)
    );
    !W || z || (s == null || s(f), i == null || i(f), f.defaultPrevented || c == null || c());
  }, v), j = Oe((f) => {
    const N = f.target;
    [
      ...d.branches
    ].some(
      (A) => A.contains(N)
    ) || (a == null || a(f), i == null || i(f), f.defaultPrevented || c == null || c());
  }, v);
  return me((f) => {
    B === d.layers.size - 1 && (r == null || r(f), !f.defaultPrevented && c && (f.preventDefault(), c()));
  }, v), b(() => {
    if (l)
      return o && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (V = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(l)), d.layers.add(l), H(), () => {
        o && d.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = V);
      };
  }, [
    l,
    v,
    o,
    d
  ]), b(() => () => {
    l && (d.layers.delete(l), d.layersWithOutsidePointerEventsDisabled.delete(l), H());
  }, [
    l,
    d
  ]), b(() => {
    const f = () => y({});
    return document.addEventListener(U, f), () => document.removeEventListener(U, f);
  }, []), /* @__PURE__ */ m(w.div, h({}, u, {
    ref: S,
    style: {
      pointerEvents: ee ? W ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: L(e.onFocusCapture, j.onFocusCapture),
    onBlurCapture: L(e.onBlurCapture, j.onBlurCapture),
    onPointerDownCapture: L(e.onPointerDownCapture, ne.onPointerDownCapture)
  }));
}), Pe = /* @__PURE__ */ E((e, n) => {
  const t = R(G), o = p(null), r = k(n, o);
  return b(() => {
    const s = o.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [
    t.branches
  ]), /* @__PURE__ */ m(w.div, h({}, e, {
    ref: r
  }));
});
function ge(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = g(e), o = p(!1), r = p(() => {
  });
  return b(() => {
    const s = (i) => {
      if (i.target && !o.current) {
        let u = function() {
          J(he, t, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: i
        };
        i.pointerType === "touch" ? (n.removeEventListener("click", r.current), r.current = u, n.addEventListener("click", r.current, {
          once: !0
        })) : u();
      } else
        n.removeEventListener("click", r.current);
      o.current = !1;
    }, a = window.setTimeout(() => {
      n.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(a), n.removeEventListener("pointerdown", s), n.removeEventListener("click", r.current);
    };
  }, [
    n,
    t
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Oe(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = g(e), o = p(!1);
  return b(() => {
    const r = (s) => {
      s.target && !o.current && J(ye, t, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", r), () => n.removeEventListener("focusin", r);
  }, [
    n,
    t
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function H() {
  const e = new CustomEvent(U);
  document.dispatchEvent(e);
}
function J(e, n, t, { discrete: o }) {
  const r = t.originalEvent.target, s = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  n && r.addEventListener(e, n, {
    once: !0
  }), o ? ve(r, s) : r.dispatchEvent(s);
}
const we = Ee, Se = Pe, Ae = /* @__PURE__ */ E((e, n) => {
  var t;
  const { container: o = globalThis == null || (t = globalThis.document) === null || t === void 0 ? void 0 : t.body, ...r } = e;
  return o ? /* @__PURE__ */ se.createPortal(/* @__PURE__ */ m(w.div, h({}, r, {
    ref: n
  })), o) : null;
}), Ne = /* @__PURE__ */ E((e, n) => /* @__PURE__ */ m(w.span, h({}, e, {
  ref: n,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), Le = Ne;
export {
  xe as $,
  h as _,
  k as a,
  q as b,
  Se as c,
  w as d,
  Ne as e,
  De as f,
  be as g,
  g as h,
  L as i,
  we as j,
  Ae as k,
  K as l,
  ve as m,
  Ee as n,
  ae as o,
  Le as p
};
